<template>
  <section id="about" class="cr-section about-area section-padding-sm  pt-0"  >
    <div class="container ">
      <div class="testimonial text-center">
        <span class="testimonial-image w-100">Foglalj időpontot!</span>
        <p class="photoghor-form-input text-center"> <a href="/#contact" type="button"  class="button"><span>Kapcsolat</span></a>
        </p>
        <span class="testimonial-border-topleft"></span>
        <span class="testimonial-border-topright"></span>
        <span class="testimonial-border-bottomleft"></span>
        <span class="testimonial-border-bottomright"></span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContactMe.vue'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ContactMe.vue